import React, { useState, Component } from 'react';
import { ViralResultCard } from '../components/Analysis/ViralResultCard';
import { WebsiteHeader } from '../components/Dashboard/WebsiteHeader';
export function DebugPage() {
  const [score, setScore] = useState(92);
  return <div className="min-h-screen bg-[#050505] text-white flex flex-col font-sans" data-id="element-4133">
      <WebsiteHeader data-id="element-4134" />

      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-12 flex flex-col lg:flex-row gap-12 items-start" data-id="element-4135">
        {/* Controls Panel */}
        <div className="w-full lg:w-1/3 bg-[#0A0A0A] border border-gray-800 rounded-2xl p-8 sticky top-24" data-id="element-4136">
          <h1 className="text-2xl font-black mb-6 tracking-tight" data-id="element-4137">
            Viral Card Debugger
          </h1>

          <div className="mb-8" data-id="element-4138">
            <label className="block text-sm font-mono text-gray-400 mb-4 uppercase tracking-wider" data-id="element-4139">
              Toxicity Score:{' '}
              <span className="text-white font-bold text-lg" data-id="element-4140">{score}%</span>
            </label>
            <input type="range" min="0" max="100" value={score} onChange={e => setScore(parseInt(e.target.value))} className="w-full h-2 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-red-500" data-id="element-4141" />
            <div className="flex justify-between text-xs font-mono text-gray-600 mt-2" data-id="element-4142">
              <span data-id="element-4143">0% (Saint)</span>
              <span data-id="element-4144">100% (Final Boss)</span>
            </div>
          </div>

          <div className="space-y-4" data-id="element-4145">
            <h3 className="text-sm font-mono text-gray-400 uppercase tracking-wider mb-2" data-id="element-4146">
              Quick Test Values
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-4147">
              <button onClick={() => setScore(15)} className="bg-gray-900 border border-gray-800 hover:border-green-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4148">
                15% (Level 1)
              </button>
              <button onClick={() => setScore(45)} className="bg-gray-900 border border-gray-800 hover:border-yellow-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4149">
                45% (Level 2)
              </button>
              <button onClick={() => setScore(75)} className="bg-gray-900 border border-gray-800 hover:border-orange-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4150">
                75% (Level 3)
              </button>
              <button onClick={() => setScore(92)} className="bg-gray-900 border border-gray-800 hover:border-red-500 py-2 rounded font-mono text-sm transition-colors" data-id="element-4151">
                92% (Level 4)
              </button>
            </div>
          </div>

          <div className="mt-8 p-4 bg-gray-900 border border-gray-800 rounded-lg" data-id="element-4152">
            <h3 className="text-sm font-bold mb-2" data-id="element-4153">Design Requirements Met:</h3>
            <ul className="text-xs text-gray-400 space-y-2 font-mono" data-id="element-4154">
              <li data-id="element-4155">✓ Charcoal Black (#0A0A0A) background</li>
              <li data-id="element-4156">✓ Neon Red/Cyber White accents</li>
              <li data-id="element-4157">✓ Monospaced tech header</li>
              <li data-id="element-4158">✓ 9:16 Mobile-first aspect ratio</li>
              <li data-id="element-4159">✓ Glowing circular gauge</li>
              <li data-id="element-4160">✓ Dynamic Meme-able Labels</li>
              <li data-id="element-4161">✓ 3 Indicator dots</li>
              <li data-id="element-4162">✓ Validation Quote Box (Serif)</li>
              <li data-id="element-4163">✓ Footer with CTA & Watermark</li>
            </ul>
          </div>
        </div>

        {/* Preview Area */}
        <div className="w-full lg:w-2/3 flex justify-center items-center bg-[#111] border border-gray-800 rounded-2xl p-12 min-h-[800px] relative overflow-hidden" data-id="element-4164">
          {/* Background grid for preview area */}
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-4165" />

          {/* The Component */}
          <div className="relative z-10 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-4166">
            <ViralResultCard score={score} data-id="element-4167" />
          </div>
        </div>
      </main>
    </div>;
}